export default __webpack_public_path__ + "static/media/2 Mueble aglomerado Buffet .697e41c6.jpeg";